<mat-card appearance="outlined">
	<mat-card-title [innerText]="cardTitle | translate"></mat-card-title>
	<mat-card-content [formGroup]="formGroupTermin" style="max-height: 65vh; overflow-y: auto; overflow-x: hidden">
		<!--DESKTOP-->
		<span class="row">
			<mat-checkbox class="checkbox" formControlName="fldPrivat">
				{{ "MAIN_APP_PENDENZEN_TERMIN.privat" | translate }}
			</mat-checkbox>

			<mat-checkbox class="checkbox" [checked]="isStoreInOutlookChecked()" (change)="storeInOutlookChanged($event.checked)">
				{{ "MAIN_APP_PENDENZEN_TERMIN.inOutlookSpeichern" | translate }}
			</mat-checkbox>
		</span>

		<span class="row">
			<mat-form-field>
				<mat-label>
					{{ "MAIN_APP_PENDENZEN_TERMIN.status" | translate }}
				</mat-label>
				<mat-select (selectionChange)="selectedAddress($event)" formControlName="fldStatus">
					<mat-option *ngFor="let status of dbStatus" [value]="status.status">
						{{ status.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.erinnerung" | translate }}</mat-label>
				<mat-select formControlName="fldErinnerung">
					<mat-option *ngFor="let reminder of dbReminder" [value]="reminder.minuten">
						{{ reminder.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.kategorien" | translate }}</mat-label>
				<mat-select formControlName="fldKategorie" multiple>
					<mat-option *ngFor="let kate of dbKategorien" [value]="kate.id">
						{{ kate.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</span>

		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.startTermin" | translate }}</mat-label>
				<input [matDatepicker]="pickerStart" formControlName="fldStartDatum" matInput required (dateChange)="startDateChanged($event)"/>
				<mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #pickerStart></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.startzeit" | translate }}
				</mat-label>
				<input formControlName="fldStartZeit" matInput type="time" (change)="startTimeChanged($event)"/>
			</mat-form-field>
		</span>

		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.endTermin" | translate }}</mat-label>
				<input [matDatepicker]="pickerEnd" formControlName="fldEndDatum" matInput required (dateChange)="endDateChanged($event)"/>
				<mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #pickerEnd></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.endzeit" | translate }}</mat-label>
				<input formControlName="fldEndZeit" matInput type="time" (change)="endTimeChanged($event)"/>
			</mat-form-field>
		</span>


		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.objekt" | translate }}</mat-label>
				<input [matAutocomplete]="auto" aria-label="Suche" formControlName="fldObjekt" matInput placeholder="Objekt wählen" required type="text"/>
				<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedSearchItem($event)" [displayWith]="getObjektDesc" autoActiveFirstOption>
					<mat-option *ngFor="let objekt of filteredDescriptions | async" [value]="objekt">
						{{ objekt.beschreibung }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
			<span class="row">

				<mat-form-field>
					<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.adresse" | translate }}</mat-label>
					<mat-select (selectionChange)="selectedAddress($event)" formControlName="fldAdresse" placeholder="Adresse wählen">
						<mat-option *ngFor="let address of objectAddresses" [value]="address">
							{{ address.zusammenfassung }}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-icon (click)="addObjectAddress()" style="width: 28px">import_contacts</mat-icon>
			</span>
		</span>

		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.ort" | translate }}</mat-label>
				<input formControlName="fldOrt" matInput/>
			</mat-form-field>

			<mat-form-field *ngIf="!showUserGroups">
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.zuständig" | translate }}</mat-label>
				<mat-select formControlName="fldMitarbeiter" multiple required>
					<mat-option *ngFor="let employe of dbMitarbeiter" [value]="employe.userID">{{ getMitarbeiter(employe) }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field *ngIf="showUserGroups">
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.zuständig" | translate }}</mat-label>
				<mat-select formControlName="fldMitarbeiter" multiple required>
					<mat-optgroup label="Mitarbeiter">
						<mat-option *ngFor="let employe of dbMitarbeiter" [value]="employe.userID">{{ getMitarbeiter(employe) }}
						</mat-option>
					</mat-optgroup>
					<mat-optgroup label="Gruppen">
						<mat-option *ngFor="let empGroup of dbGruppen" [value]="empGroup.id">{{ empGroup.description }}</mat-option>
					</mat-optgroup>
				</mat-select>
			</mat-form-field>
		</span>

		<mat-form-field>
			<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.titel" | translate }}</mat-label>
			<input formControlName="fldTitel" matInput/>
		</mat-form-field>

		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.notizen" | translate }}</mat-label>
				<textarea formControlName="fldNotizen" matInput style="min-height: 150px"></textarea>
			</mat-form-field>
		</span>

	</mat-card-content>
	<mat-dialog-actions>
		<button (click)="save()" [disabled]="!formGroupTermin.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
		<button [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-dialog-close mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>
